<template>
  <div class="Modal" :class="{'Opened': visible}">
    <div class="ModalContainer">
      <div class="ModalContent">
        <div class="ModalBody">
          <div v-html="header"></div>
        </div>
        <div class="ModalBody">
          <div v-html="text"></div>
        </div>
      </div>
      <button @click="onApprove">Onayla</button>
      <!--<button @click="onClose">Kapat</button>-->
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: "ApproveModal",
  components: {
  },
  props: {
    visible: {
      required: true
    },
    text: {
      required:true
    },
    header: {}
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onApprove() {
      this.$emit('approve');
    }
  }
};
</script>